import type { Candidate } from './types';

/**
 * Der nächste offene Prüfling — nach dem aktuellen in der Liste, sonst der erste offene
 * überhaupt.
 *
 * Offen heisst: nicht entschuldigt, nicht bewertet und an diesem Gerät nicht abgesendet.
 *
 * Eine Regel für zwei Stellen: `goToNextCandidate` im Store wechselt dorthin, und der
 * Bestätigungsdialog nennt den Namen schon auf seinem Knopf (`next_candidate_button`). Liefen
 * die beiden auseinander, stünde auf dem Knopf ein anderer Name als der, der dann kommt.
 */
export function naechsterOffener(
  candidates: readonly Candidate[],
  abgesendet: Readonly<Record<string, unknown>>,
  aktuellId: string,
): Candidate | null {
  const offen = candidates.filter(
    (c) => c.state !== 'entschuldigt' && !abgesendet[c.id] && c.state !== 'bewertet',
  );
  const von = candidates.findIndex((c) => c.id === aktuellId);
  return offen.find((c) => candidates.indexOf(c) > von) ?? offen[0] ?? null;
}
